export const StaticTextFields = {
    header: {
        pageName: 'Header',
        list: [
            {
                label: "Header - name",
                key: "header_name"
            },
            {
                label: "Header - name country",
                key: "header_name_country"
            },
            {
                label: "Header - menu",
                key: "header_menu"
            },
            {
                label: "Header - item home",
                key: "header_item_home"
            },
            {
                label: "Header - item brands",
                key: "header_item_brands"
            },
            {
                label: "Header - item partners",
                key: "header_item_partners"
            },
            {
                label: "Header - item blog",
                key: "header_item_blog"
            },
            {
                label: "Header - item about",
                key: "header_item_about"
            },
            {
                label: "Header - item contact",
                key: "header_item_contact"
            },
            {
                label: "Header - item connect",
                key: "header_item_connect"
            },
        ]
    },
    homepage: {
        pageName: 'Homepage',
        list: [
            {
                label: "Homepage - brandes title",
                key: "home_brandes_title"
            },
            {
                label: "Homepage - brandes description",
                key: "home_brandes_description"
            },
            {
                label: "Homepage - see all",
                key: "home_see_all"
            },
            {
                label: "Homepage - more",
                key: "home_more"
            },
            {
                label: "Homepage - partners title",
                key: "home_partners_title"
            },
            {
                label: "Homepage - partners description",
                key: "home_partners_description"
            },
            {
                label: "Homepage - partners join",
                key: "home_partners_join"
            },
            {
                label: "Homepage - partners see",
                key: "home_partners_see"
            },
            {
                label: "Homepage - blog title",
                key: "home_blog_title"
            },
            {
                label: "Homepage - blog description",
                key: "home_blog_description"
            },
            {
                label: "Homepage - info second button",
                key: "homepage_info_second_btn"
            },
            {
                label: "Homepage - special products title",
                key: "homepage_special_products_title"
            },
        ]
    },
    footer: {
        pageName: 'Footer',
        list: [
            {
                label: "Footer - brands title",
                key: "footer_brands_title"
            },
            {
                label: "Footer - medias title",
                key: "footer_medias_title"
            },
            {
                label: "Footer - cooperation",
                key: "footer_cooperation"
            },
        ]
    },
    about: {
        pageName: 'About',
        list: [
            {
                label: "About - page title",
                key: "about_page_title"
            },
            {
                label: "About - page description",
                key: "about_page_description"
            },
        ]
    },
    blog: {
        pageName: 'Blog',
        list: [
            {
                label: "Blog - page title",
                key: "blog_page_title"
            },
            {
                label: "Blog - page description",
                key: "blog_page_description"
            },
            {
                label: "Blog - detail last title",
                key: "blog_detail_last_title"
            },
            {
                label: "Blog - detail last description",
                key: "blog_detail_last_description"
            },
        ]
    },
    brande: {
        pageName: 'Brande',
        list: [
            {
                label: "Brande - page tab all",
                key: "brandes_page_tab_all"
            },
            {
                label: "Brande - page title",
                key: "brandes_page_title"
            },
            {
                label: "Brande - page description",
                key: "brandes_page_description"
            },
            {
                label: "Brande - page hover more",
                key: "brandes_page_more"
            },
            {
                label: "Product - detail tab description",
                key: "product_detail_tab_description"
            },
            {
                label: "Product - detail tab utilize",
                key: "product_detail_tab_utilize"
            },
            {
                label: "Product - detail tab brand",
                key: "product_detail_tab_brand"
            },
            {
                label: "Product - detail tab ingredients",
                key: "product_detail_tab_ingredients"
            },
            {
                label: "Product - detail buy title",
                key: "product_detail_buy_title"
            },
            {
                label: "Product - detail buy description",
                key: "product_detail_buy_description"
            },
            {
                label: "Product - bestSeller title",
                key: "bestSeller_title"
            },
            {
                label: "Product - empty text",
                key: "product_empty_text"
            },
        ]
    },
    partner: {
        pageName: 'Partner',
        list: [
            {
                label: "Partner - page title",
                key: "partner_page_title"
            },
            {
                label: "Partner - page description",
                key: "partner_page_description"
            },
            {
                label: "Partner - page hover text",
                key: "partner_page_hover_text"
            },
            {
                label: "Partner - page join title",
                key: "partner_page_join_title"
            },
            {
                label: "Partner - page join description",
                key: "partner_page_join_description"
            },
            {
                label: "Partner - page join firstName placeholder",
                key: "partner_page_join_firstName_placeholder"
            },
            {
                label: "Partner - page join firstName label",
                key: "partner_page_join_firstName_label"
            },
            {
                label: "Partner - page join lastName placeholder",
                key: "partner_page_join_lastName_placeholder"
            },
            {
                label: "Partner - page join lastName label",
                key: "partner_page_join_lastName_label"
            },
            {
                label: "Partner - page join email placeholder",
                key: "partner_page_join_email_placeholder"
            },
            {
                label: "Partner - page join email label",
                key: "partner_page_join_email_label"
            },
            {
                label: "Partner - page join phone placeholder",
                key: "partner_page_join_phone_placeholder"
            },
            {
                label: "Partner - page join phone label",
                key: "partner_page_join_phone_label"
            },
            {
                label: "Partner - page join send",
                key: "partner_page_join_send"
            },
        ]
    },
    contacts: {
        pageName: 'Contacts',
        list: [
            {
                label: "Contacts - Page title",
                key: "contact_page_title"
            },
            {
                label: "Contacts - Page description",
                key: "contact_page_description"
            },
            {
                label: "Contacts - Page info title",
                key: "contact_page_info_title"
            },
            {
                label: "Contacts - Page info description",
                key: "contact_page_info_description"
            },
            {
                label: "Contacts - Page firstName placeholder",
                key: "contact_page_firstName_placeholder"
            },
            {
                label: "Contacts - Page firstName label",
                key: "contact_page_firstName_label"
            },
            {
                label: "Contacts - Page lastName placeholder",
                key: "contact_page_lastName_placeholder"
            },
            {
                label: "Contacts - Page lastName label",
                key: "contact_page_lastName_label"
            },
            {
                label: "Contacts - Page email placeholder",
                key: "contact_page_email_placeholder"
            },
            {
                label: "Contacts - Page email label",
                key: "contact_page_email_label"
            },
            {
                label: "Contacts - Page phone placeholder",
                key: "contact_page_phone_placeholder"
            },
            {
                label: "Contacts - Page phone label",
                key: "contact_page_phone_label"
            },
            {
                label: "Contacts - Page message placeholder",
                key: "contact_page_message_placeholder"
            },
            {
                label: "Contacts - Page message label",
                key: "contact_page_message_label"
            },
            {
                label: "Contacts - Page send btn",
                key: "contact_page_send_btn"
            },
            {
                label: "Subscribe - title",
                key: "subscribe_title"
            },
            {
                label: "Subscribe - description",
                key: "subscribe_description"
            },
            {
                label: "Subscribe - email placeholder",
                key: "subscribe_email_placeholder"
            },
            {
                label: "Subscribe - subscribe btn",
                key: "subscribe_subscribe_btn"
            },
        ]
    },
}